var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"ml-1",attrs:{"color":_vm.approved ? 'light-green darken-3' : 'grey lighten-1',"small":""}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.approved ? "mdi-check-decagram" : "mdi-alert-decagram")+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])}
var staticRenderFns = []

export { render, staticRenderFns }